import { completeEnglishIqV1Api } from '@repo/sdk';
import { requireEnglishIqResponseData } from './require-english-iq-response-data';

export async function completeEnglishIqWebSession(token: string) {
  const response = await completeEnglishIqV1Api({ token });
  return requireEnglishIqResponseData(response.data.data);
}
